var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 .933c3.356 0 6.07 2.71 6.07 6.067A6.066 6.066 0 0 1 8 14.07 6.063 6.063 0 0 1 1.933 8 6.06 6.06 0 0 1 8 1.933zM7.994 4.27a.467.467 0 0 0-.459.473v.392c-.753.142-1.398.627-1.398 1.468 0 .583.263 1.055.616 1.33.353.274.752.396 1.102.513.35.116.652.228.824.362.172.133.254.246.254.596 0 .778-1.863.778-1.863 0a.467.467 0 1 0-.933 0c0 .84.645 1.326 1.398 1.468v.391a.467.467 0 1 0 .933 0v-.39c.754-.143 1.4-.629 1.4-1.47 0-.583-.264-1.054-.617-1.33-.354-.274-.752-.396-1.102-.513-.35-.117-.653-.227-.824-.361-.172-.134-.255-.246-.255-.596 0-.778 1.863-.778 1.863 0a.467.467 0 0 0 .935 0c0-.84-.647-1.325-1.4-1.467v-.393a.467.467 0 0 0-.474-.473z",
    fill: "#848383",
    fillRule: "nonzero",
    stroke: "#848383",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBlack);
export default __webpack_public_path__ + "static/media/payment-black.d22e8805f0c41e0d80df22c794093e4b.svg";
export { ForwardRef as ReactComponent };